var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled, { css } from 'styled-components';
import { components } from 'react-select';
import Icon, { IconName } from '../../../Icon';
export var Group = function (groupItem) {
    var selectProps = groupItem.selectProps, children = groupItem.children;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var themeFamily = selectProps.themeFamily;
    return (_jsxs(GroupWrapper, { children: [_jsxs(HeaderGroup, __assign({ themeFamily: themeFamily, onClick: function () { return setIsOpen(!isOpen); } }, { children: [groupItem.label, _jsx(IconWrapper, { children: isOpen ? _jsx(Icon, { name: IconName.CHEVRON_UP }, void 0) : _jsx(Icon, { name: IconName.CHEVRON_DOWN }, void 0) }, void 0)] }), void 0),
            _jsx(GroupBody, { children: isOpen && _jsx(components.Group, __assign({}, groupItem, { children: children }), void 0) }, void 0)] }, void 0));
};
export var GroupHeading = function () { return _jsx("div", {}, void 0); };
var GroupWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  cursor: pointer;\n"], ["\n  position: relative;\n  cursor: pointer;\n"])));
var HeaderGroup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  font-size: 14px;\n  cursor: pointer;\n  pointer-events: auto;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 16px 20px;\n  font-size: 14px;\n  cursor: pointer;\n  pointer-events: auto;\n\n  ",
    "\n"])), function (_a) {
    var theme = _a.theme, themeFamily = _a.themeFamily;
    var text = theme.families.search[themeFamily].text;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), text);
});
var IconWrapper = styled.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n"], ["\n  position: absolute;\n  right: 10px;\n"])));
var GroupBody = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  padding-left: 20px;\n"], ["\n  padding-left: 20px;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
